var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFuelStat = function SvgFuelStat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1036.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3804",
    width: 8.7,
    height: 8.266,
    x: 1.3,
    y: 1042.8,
    fill: "currentColor",
    rx: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2996",
    fill: "currentColor",
    d: "M3.313 1.313c-1.109 0-2 .892-2 2v7.968c0 1.108.892 2 2 2H8c1.108 0 2-.892 2-2V3.312c0-1.107-.892-2-2-2zm.093 1.28h4.5c.443 0 .782.37.782.813v1.781c0 .444-.339.813-.782.813h-4.5a.82.82 0 0 1-.812-.813v-1.78a.82.82 0 0 1 .812-.813",
    transform: "translate(0 1036.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path3768",
    cx: 12.737,
    cy: 6.94,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.169,
    rx: 1.436,
    ry: 1.294,
    transform: "matrix(.97472 0 0 1.0817 .185 1035.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3774",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.817 9.4h1.468l.048 2.165c0 .413.394 1.105 1.341 1.105s1.279-.655 1.279-1.058l.031-5.666-3.046-2.936",
    transform: "translate(0 1036.4)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelStat);
export default ForwardRef;